import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormService,
  FormServiceResolver,
} from "../../../core/services/v2/form.service";
import { WindowLoaderService } from "../../../shared/components/window-loader/window-loader.service";
import { FormDoc } from "../../../core/models/physician/form-doc";
import { SafeHtml } from "@angular/platform-browser";
import {
  FormDocBuilder,
  FormHeader,
  FormFooter,
} from "../../../core/models/physician/form-doc-builder";
import { MatDialog, MatSnackBar } from "@angular/material";
import { FormPreviewFromBuilderDtoComponent } from "../form-preview/form-preview-from-builder-dto.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MyErrorStateMatcher } from "../../../shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component";
import { Location as aLocation } from "@angular/common";
import { CommonService } from "src/app/core/services/v2/common.service";
import { CodeTable } from "src/app/core/model/v2/code-table";
import * as _ from "lodash";

declare const WebViewer: any;

@Component({
  selector: "app-form-document-details",
  templateUrl: "./form-document-details.component.html",
  styleUrls: ["./form-document-details.component.scss"],
})
export class FormDocumentDetailsComponent implements OnInit {
  @ViewChild("viewer", { static: false }) viewer: ElementRef;
  @ViewChild("fileupload", { static: false }) fileupload: ElementRef;
  filename: string = "acroform.pdf";
  wvInstance: any;
  acroformBlob: Blob;
  formDocument: FormDoc;
  isselectFileDisable: boolean;
  // formBuilder: FormDocBuilder;
  errorMessage: string;
  id: number;
  sectionName: string;
  toggleSidebar = false;

  sideBarHeader: string = "Add to Folder";

  codeFormControl = new FormControl("", [Validators.required]);
  titleFormControl = new FormControl("", [Validators.required]);
  formGroupId = new FormControl("", []);
  summaryFormControl = new FormControl("", []);

  setSidebarHeader() {
    switch (this.sectionName) {
      case "managefolders":
        this.sideBarHeader = "Folders";
        break;
      case "addtofolders":
        this.sideBarHeader = "Add to Folder";
        break;
    }
  }

  formDocForm: FormGroup = new FormGroup({
    code: this.codeFormControl,
    title: this.titleFormControl,
    summary: this.summaryFormControl,
    formGroupId: this.formGroupId,
  });

  formDocMatcher = new MyErrorStateMatcher();

  showFormPreview: Boolean = false;
  formFolders: any = [];
  iframeLocalUrl: SafeHtml;
  acroFormPrefildCodes: any = [];

  constructor(
    private _formServiceResolver: FormServiceResolver,
    private _route: ActivatedRoute,
    private _router: Router,
    private _loaderService: WindowLoaderService,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _location: aLocation,
    private formService: FormService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formService.getAcrFormsFields().subscribe(
      (res) => {
        if (res.resultStatus.isSuccess) {
          this.acroFormPrefildCodes = res.result;
        } else console.error(res);
      },

      (error) => console.log(error)
    );

    this.formService.getFormsGroups().subscribe(
      (list) => {
        this.formFolders = _.orderBy(
          list.result,
          [(folder) => folder.name.toLowerCase()],
          ["asc"]
        );
        //this.checkForSelectedFolders();
      },
      (error) => {
        console.error(error);
      }
    );

    this.formDocument = new FormDoc();
    this._route.params.subscribe(
      (params) => {
        this.id = +params["id"];
        if (this.id && this.id > 0) {
          this.isselectFileDisable = true;
          //this.getFormDocumentDetails();
        } else {
          this.setDefaults();
          this.isselectFileDisable = false;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  //Pdftron
  ngAfterViewInit(): void {
    // The following code initiates a new instance of WebViewer.

    WebViewer(
      {
        disabledElements: [
          //'ribbons',
          "toggleNotesButton",
          "searchButton",
          //'menuButton',
          "rubberStampToolGroupButton",
          "stampToolGroupButton",
          "fileAttachmentToolGroupButton",
          "calloutToolGroupButton",
          //'undo',
          //'redo',
          "eraserToolButton",
        ],
        path: "./wv-resources/lib",
        // initialDoc: './assets/pdf/AH-SaaS Agreement - March 2021 v3.pdf'
      },
      this.viewer.nativeElement
    ).then((instance) => {
      if (this.id == 0) {
        this.fileupload.nativeElement.addEventListener("change", () => {
          // Get the file from the input
          const file = this.fileupload.nativeElement.files[0];
          this.filename = file.name.substr(0, file.name.lastIndexOf("."));
          instance.UI.loadDocument(file, { filename: file.name });
        });
      }
      if (this.id != 0) {
        this.getFormDocumentDetails();
        //this.setFormDocFormControls();
      }
      this.wvInstance = instance;
      const { documentViewer, annotationManager, Annotations, SaveOptions } =
        instance.Core;
      const { WidgetFlags } = Annotations;
      const { Feature } = instance.UI;
      instance.UI.setToolbarGroup("toolbarGroup-Forms");

      //instance.UI.enableFeatures([Feature.FilePicker]);
      instance.UI.disableElements(["toolbarGroup-Annotate"]);
      instance.UI.disableElements(["toolbarGroup-Shapes"]);
      // instance.UI.disableElements(['toolbarGroup-Edit']);
      instance.UI.disableElements(["toolbarGroup-Insert"]);
      //instance.UI.disableElements(['toolbarGroup-Insert']);

      instance.UI.disableElements(["toolbarGroup-FillAndSign"]);

      // remove left panel and left panel button from the DOM
      instance.UI.disableElements(["leftPanel", "leftPanelButton"]);

      // now you can access APIs through this.webviewer.getInstance()
      //instance.UI.openElement('notesPanel');
      // see https://www.pdftron.com/documentation/web/guides/ui/apis
      // for the full list of APIs

      // or listen to events from the viewer element
      this.viewer.nativeElement.addEventListener("pageChanged", (e) => {
        const [pageNumber] = e.detail;
        console.log(`Current page is ${pageNumber}`);
      });

      const normalStyles = (widget) => {
        if (widget instanceof Annotations.TextWidgetAnnotation) {
          return {
            "background-color": "#a5c7ff",
            color: "white",
          };
        } else if (widget instanceof Annotations.SignatureWidgetAnnotation) {
          return {
            border: "1px solid #a5c7ff",
          };
        }
      };

      annotationManager.addEventListener(
        "annotationChanged",
        async (annotations, action, { imported }) => {
          documentViewer.getAnnotationsLoadedPromise().then(() => {
            const fieldManager = annotationManager.getFieldManager();
            var allfields = fieldManager.getFields();
          });
          //if (action === 'add') {
          const doc = documentViewer.getDocument();
          const xfdfString = await annotationManager.exportAnnotations();
          const saveOptions = SaveOptions;
          const options = {
            xfdfString,
            // flags: saveOptions.LINEARIZED,
            downloadType: "pdf",
          };
          const data = await doc.getFileData(options);
          const arr = new Uint8Array(data);
          this.acroformBlob = new Blob([arr], { type: "application/pdf" });
          // upload blob to your server
          //var f= new File([this.acroformBlob], "fileName.pdf", { lastModified: new Date().getTime(), type: this.acroformBlob.type });
          //var url= window.URL.createObjectURL(this.acroformBlob);
          //window.open(url);
          //console.log(f);
          annotations.forEach(function (annot) {
            if (annot instanceof Annotations.WidgetAnnotation) {
              Annotations.WidgetAnnotation.getCustomStyles = normalStyles;
              // if (!annot.fieldName.startsWith(email)) {
              //   annot.Hidden = true;
              //   annot.Listable = false;
              // }
            }
          });
          //}
        }
      );
      documentViewer.addEventListener("documentLoaded", async () => {
        const doc = documentViewer.getDocument();
        const xfdfString = await annotationManager.exportAnnotations();
        const saveOptions = SaveOptions;
        const options = {
          xfdfString,
          // flags: saveOptions.LINEARIZED,
          downloadType: "pdf",
        };
        const data = await doc.getFileData(options);
        const arr = new Uint8Array(data);
        this.acroformBlob = new Blob([arr], { type: "application/pdf" });
        documentViewer.getAnnotationsLoadedPromise().then(() => {
          const fieldManager = annotationManager.getFieldManager();
          //Set value
          //txt_ClientNamefield.setValue('Client Name');
          const fieldManager1 = annotationManager.getFieldManager();
          var allfields1 = fieldManager1.getFields();
          console.log(allfields1);
        }); //
      });
    });
  }

  //EndPdftron

  toggleEditSidebar(sectionName: string) {
    this.sectionName = sectionName;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);

    //this.destroyChild();
  }

  togglePopUp(formDoc: any) {
    this.formService.getFormsGroups().subscribe(
      (list) => {
        this.formFolders = _.orderBy(
          list.result,
          [(folder) => folder.name.toLowerCase()],
          ["asc"]
        );
        //this.checkForSelectedFolders();
      },
      (error) => {
        console.error(error);
      }
    );
    if (formDoc) this.formDocument = formDoc;

    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    //this.destroyChild();
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }
  private setFormDocFormControls() {
    this.codeFormControl.setValue(
      this.formDocument ? this.formDocument.code : ""
    );
    this.titleFormControl.setValue(
      this.formDocument ? this.formDocument.title : ""
    );
    this.summaryFormControl.setValue(
      this.formDocument ? this.formDocument.summary : ""
    );
    console.log("file");

    if (this.formDocument) {
      if (this.formDocument.formGroupIds)
        this.formGroupId.setValue(
          this.formDocument ? this.formDocument.formGroupIds[0] : ""
        );
      if (this.formDocument.formUrl && this.wvInstance) {
        console.log(this.formDocument.formUrl);
        this.wvInstance.UI.loadDocument(this.formDocument.formUrl, {
          filename: "myfile.pdf",
        });
      }
    }
  }

  private getFormDocumentDetails() {
    var self = this;
    //)
    this._formServiceResolver.getFormService().subscribe((fsvc) => {
      this._loaderService.blockWithLoader(fsvc.getFormDoc(self.id)).subscribe(
        (formd) => {
          self.formDocument = formd.result;
          this.setFormDocFormControls();
        },
        (error) => {
          console.error(error);
        },
        () => {
          fsvc.getFormBuilder(self.id).subscribe(
            (formb) => {
              //self.formBuilder = formb.result;
              self.setDefaults();
            },
            (error) => {
              console.error(error);
            }
          );
        }
      );
    });
  }
  private setDefaults() {
    if (!this.formDocument) {
      this.formDocument = new FormDoc();
      this.id = 0;
      this.formDocument.id = 0;
    }
    // if (!this.formBuilder) {
    //   this.formBuilder = new FormDocBuilder();
    //   this.formBuilder.blocks = [];
    // }

    // if (!this.formBuilder.header) {
    //   this.formBuilder.header = new FormHeader();
    // }

    // if (!this.formBuilder.footer) {
    //   this.formBuilder.footer = new FormFooter();
    // }

    // if (!this.formBuilder.blocks) {
    //   this.formBuilder.blocks = [];
    // }
  }

  cancel() {
    this._location.back();
  }

  saveForm() {
    if (this.formDocForm.invalid) {
      this._snackBar.open("Fill required fields", "Ok", {
        duration: 5000,
      });

      return;
    }

    var self = this;

    self.formDocument.code = this.codeFormControl.value;
    self.formDocument.title = this.titleFormControl.value;
    self.formDocument.summary = this.summaryFormControl.value;
    self.formDocument.formGroupId = this.formGroupId.value;

    if (!this.acroformBlob) {
      self._snackBar.open(`Select File`, "Ok");
    } else {
      var f = new File([this.acroformBlob], this.filename + ".pdf", {
        lastModified: new Date().getTime(),
        type: this.acroformBlob.type,
      });
      self.formDocument.file = f;
      // var url= window.URL.createObjectURL(this.acroformBlob);
      // window.open(url);
      // //console.log(f);
      //if (self.id == 0) {
      // console.log(self.formDocument);
      self._formServiceResolver.getFormService().subscribe((fsvc) =>
        self._loaderService
          .blockWithLoader(fsvc.addFormDoc(self.formDocument))
          .subscribe(
            (formd) => {
              if (formd.resultStatus.isSuccess) {
                self.id = formd.result.id;
                self._snackBar.open("Form was successfully added", "Ok", {
                  duration: 5000,
                });
                this._location.back();
              } else {
                console.error(formd);
                self._snackBar.open(
                  `Form was not added: ${formd.resultStatus.message}`,
                  "Ok"
                );
              }
            },
            (error) => {
              console.error(error);
              self._snackBar.open(
                `Form could not be added${
                  error.error && error.error.resultStatus
                    ? ": " + error.error.resultStatus.message
                    : ""
                }`,
                "Ok",
                {
                  duration: 5000,
                }
              );
            },
            () => {
              // console.log('formBuilder', self.formBuilder);
              // fsvc.updateFormBuilder(self.id, self.formBuilder).subscribe(
              //   (formb) => {
              //     if (formb.resultStatus.isSuccess) {
              //       self.formBuilder = formb.result;
              //       self.setDefaults();
              //       self._snackBar.open("Form content was successfully saved", "Ok", {
              //         duration: 5000
              //       });
              //     } else {
              //       console.error(formb);
              //       self._snackBar.open(`Form content was not saved: ${formb.resultStatus.message}`, "Ok");
              //     }
              //   },
              //   (error) => {
              //     console.error(error);
              //     self._snackBar.open(`Form content could not be saved${(error.error && error.error.resultStatus ? ': ' + error.error.resultStatus.message : '')}`, "Ok", {
              //       duration: 5000
              //     });
              //   }, () => {
              //     self._router.navigate([`${fsvc.spaFormDetailsRoute}${self.id}`]);
              //   }
              // );
            }
          )
      );
      //}
    }
  }

  previewForm() {
    this._dialog.open(FormPreviewFromBuilderDtoComponent, {
      panelClass: "custom-dialog-container",
      id: "formPreview",
      width: "95%",
      height: "90%",
      data: {
        formId: this.id,
        //formDocBuilder: this.formBuilder
      },
    });

    //this.showFormPreview = !this.showFormPreview ;
  }
}
